import React, { useEffect, useState } from "react";
import "./taskitem.css";
import rightArrow from "../../assets/rightArrow.svg";
import getFormattedNumber from "../../hooks/getFormattedNumber";
import coin from "../../assets/dailySession/coin.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import tooltip from "../../assets/tooltip.svg";
import validateKucoin from "../../hooks/validateKucoin";

const TaskItem = ({ item, handleCompleteTask, page }) => {
  const [loading, setLoading] = useState(false);
  const [check, setCheck] = useState(false);
  const [kucoinId, setKucoinId] = useState("");
  const [error, setError] = useState("");

  const completeTask = (id) => {
    setLoading(true);
    setTimeout(() => {
      if (check) {
        handleCompleteTask(id);
        setLoading(false);
      } else {
        setLoading(false);
        toast.error("You have not completed the task!", {
          className: "custom-toast",
          progressClassName: "custom-progress",
        });
      }
    }, 4000);
  };
  const completeSecretTask = (id, secret) => {
    setError(validateKucoin(secret));
    if (validateKucoin(secret) === "") {
      setLoading(true);
      setTimeout(() => {
        if (check) {
          handleCompleteTask(id, secret);
          setLoading(false);
        } else {
          setLoading(false);
          toast.error("You have not completed the task!", {
            className: "custom-toast",
            progressClassName: "custom-progress",
          });
        }
      }, 4000);
    }
  };

  useEffect(() => {
    if (item.type === "telegram" || item.type === "open_chest") {
      setCheck(true);
    }
  }, [item]);

  const handleRedirect = (url) => {
    window.Telegram.WebApp.openLink(url);
  };

  return (
    <div
      className="d-flex flex-column task-item-wrapper"
      style={{ cursor: "pointer" }}
    >
      <div
        style={{
          textDecoration: "none",
          pointerEvents: loading ? "none" : "auto",
        }}
        className={`home-task-item p-2 d-flex w-100 align-items-center justify-content-between`}
      >
        <div
          className="d-flex align-items-center gap-2"
          style={{width: "75%"}}
          onClick={() => {
            handleRedirect(item.link);
            setCheck(true);
          }}
        >
          <div className="position-relative">
            {page === "partner" ? (
                    <>
                    {item.type === "open_chest" ? (
                      <img
                        src={require(`../../assets/${item.type}.png`)}
                        height={36}
                        width={36}
                        alt=""
                      />
                    ) : (
                      <img
                        src={require(`../../assets/${item.type}.svg`)}
                        height={36}
                        width={36}
                        alt=""
                      />
                    )}
                  </>
            ) : (
              <img
                src={require(`../../assets/${item.partner}.svg`)}
                height={36}
                width={36}
                alt=""
              />
            )}
            {page !== "partner" && (
             <>
             {item.type === "open_chest" ?
             <img
             src={require(`../../assets/${item.type}.png`)}
             alt=""
             className="type-icon"
           />
           :
           <img
           src={require(`../../assets/${item.type}.svg`)}
           alt=""
           className="type-icon"
         /> 
            }
             </>
            )}
          </div>
          <div className="d-flex flex-column gap-2">
            <span
              className="home-task-name"
              style={{ textDecoration: "none", color: "#46557B" }}
            >
              {item.title}
            </span>
            <div className="d-flex align-items-center gap-2">
              <div className="d-flex align-items-center gap-2">
                <div className="task-reward-wrapper d-flex align-items-center gap-1">
                  <img src={coin} width={20} height={20} alt="" />
                  <span className="task-reward-amount">
                    +{getFormattedNumber(item.reward, 0)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {item.type === "kucoin" && item.action === "create" ? (
          <></>
        ) : loading ? (
          <div class="spinner-border spinner-border-sm text-info" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        ) : (
          <div className="d-flex align-items-center gap-2" style={{width: "25%"}}>
            <div
              className="check-button d-flex align-items-center py-1 gap-1 px-2"
              onClick={() => completeTask(item._id)}
            >
              <span className="check-task">Check</span>
            </div>
            <img src={rightArrow} alt="rightarrow" />
          </div>
        )}
      </div>
        {item.partner === "bitget" ? (
        <>
          <div className="kucoin-id-wrapper w-100 p-3 d-flex flex-column gap-2">
            <div className="d-flex align-items-center justify-content-between mb-2">
              <span className="kucoin-title">Enter Bitget UID</span>
              {/* <a
                href="https://www.kucoin.com/support/900002630203#:~:text=KuCoin%20has%20launched%20a%20UID,to%20find%20your%20KuCoin%20UID"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={tooltip} width={20} height={20} alt="" />
              </a> */}
            </div>
            <div className="d-flex align-items-start justify-content-between">
              <div className="d-flex flex-column gap-1 w-75">
              <input
                type="text"
                placeholder="UID"
                value={kucoinId}
                onChange={(e) => setKucoinId(e.target.value)}
                className="px-2 associate-wallet-input w-100"
            style={{ border: error !== "" && "1px solid #FF8168" }}
              />
              {error !== "" && <span style={{ color: "#FF8168" }}>{error}</span>}
              </div>
              {loading ? (
                <div
                  class="spinner-border spinner-border-sm text-info"
                  role="status"
                >
                  <span class="visually-hidden">Loading...</span>
                </div>
              ) : (
                <div className="d-flex align-items-center gap-2">
                  <div
                    className="check-button d-flex align-items-center py-1 gap-1 px-2"
                    onClick={() => completeSecretTask(item._id, kucoinId)}
                    style={{
                      height: "32px",
                      pointerEvents: kucoinId === "" ? "none" : "auto",
                      border:
                        kucoinId === ""
                          ? "1px solid #9D98B6"
                          : "1px solid #5690ff",
                    }}
                  >
                    <span
                      className="check-task"
                      style={{
                        color: kucoinId === "" ? " #9D98B6" : " #5690ff",
                      }}
                    >
                      Check
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default TaskItem;
